/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useEffect, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import Timer from 'src/components/Counter';
import { DIV } from 'src/components/CustomStyledComponents';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import InfoPtp from 'src/components/InfoPtp';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import useEffectOnce from 'src/hooks/useEffectOnce';
import useLoading from 'src/hooks/useLoading';
import usePtp from 'src/hooks/usePtp';
import { guardarLead } from 'src/services';
// import useEstadoSuscripcion from "src/hooks/useEstadoSuscripcion"


const PtpPagoSuscripcion = ({ params, cotizacion, history, idCotizacion }) => {
  const { idSuscripcion } = params;

  // const {estado, verificarSuscripcion} = useEstadoSuscripcion({idSuscripcion, idCotizacion})

  const [estadoSuscripcion, setEstadoSuscripcion] = useState('');
  const [estadoPago2, setestadoPago2] = useState({});
  const { addWarningToast, addSuccessToast, addErrorToast } = useCustomToast();
  const { values, setLoading, resetLoading, setSecundario } = useLoading();
  const { consultarEstadoSuscripcion, consultarEstadoPago, ESTADOS_SUSCRIPCION } = usePtp();
  const [verificandoEstado, setVerificandoEstado] = useState(false);

  const redireccionar = () => {
    if (cotizacion?.producto?.realizaPrimerCobro === "1") {
      return history.push(`/primer-pago-suscripcion/${idCotizacion}/${idSuscripcion}`);
    }
    else if (`${cotizacion.producto.tieneFirma}` === '1') {
      switch (cotizacion.medioFirma) {
        case 'evicertia': return history.push(`/firmarCertificado/${idCotizacion}`);
        case 'fisica': return history.push(`/ingresarPoliza/${idCotizacion}/`);
        case 'token': return history.push(`/verificarTokenPago/${idCotizacion}/${idCotizacion}`);
        default:
          break;
      }
    } else {
      return history.push(`/ingresarPoliza/${idCotizacion}/`);
    }

  }

  const init = async () => {
    setLoading(true);
    setSecundario('Estamos verificando el estado de tu suscripción');
    let traEstado = await consultarEstadoSuscripcion(idSuscripcion);

    setestadoPago2(traEstado?.data ?? {});//-----------------
    if (traEstado?.hasError) {
      return guardarLead(idCotizacion, `P2P_PAGO_SUSCRIPCION__HAS_ERROR_${traEstado?.hasError}`);
    }
    guardarLead(idCotizacion, `P2P_PAGO_SUSCRIPCION__ESTADO_${traEstado?.estado}`);
    if (traEstado?.estado === ESTADOS_SUSCRIPCION.APROBADO) {
      addSuccessToast(`Transacción aprobada \nRef: ${traEstado.data?.pago_id}`)
      redireccionar();
    } else if (traEstado?.estado === ESTADOS_SUSCRIPCION.PENDIENTE) {
      addWarningToast(`Transacción pendiente \nRef: ${traEstado.data?.pago_id}`)
    } else if (traEstado?.estado === ESTADOS_SUSCRIPCION.RECHAZADO) {
      addErrorToast(`Transacción rechazada \nRef: ${traEstado.data?.pago_id}`)
    }

    if (traEstado?.estado === ESTADOS_SUSCRIPCION.PENDIENTE) {

      traEstado = await consultarEstadoPago()
    }
    resetLoading();
    setEstadoSuscripcion(traEstado?.estado);
  };

  useEffectOnce(() => {
    guardarLead(idCotizacion, `P2P_PAGO_SUSCRIPCION__INGRESO`);
    init();
  });

  useEffect(() => {
    let bucle = null;
    if (estadoSuscripcion === ESTADOS_SUSCRIPCION.PENDIENTE) {
      bucle = setInterval(async () => {
        setVerificandoEstado(true);
        const traEstado = await consultarEstadoPago()

        if (traEstado.hasError) {
          addWarningToast('Ha ocurrido un problema al verificar el estado de la suscripción');
        } else {
          if (traEstado.estado === ESTADOS_SUSCRIPCION.APROBADO) {
            addSuccessToast(`Transacción aprobada \nRef: ${traEstado.data?.pago_id}`)
            clearInterval(bucle);
            redireccionar();
          } else if (traEstado.estado === ESTADOS_SUSCRIPCION.RECHAZADO) {
            addErrorToast(`Transacción rechazada \nRef: ${traEstado.data?.pago_id}`)
            clearInterval(bucle);
            setEstadoSuscripcion(traEstado?.estado);
          }
          setVerificandoEstado(false);
        }
      }, 60000);
      //}, 5000);
    }

    return () => {
      clearInterval(bucle);
    };
  }, [estadoSuscripcion, idSuscripcion]);



  const onClickIntentarNuevamente = () => {
    guardarLead(idCotizacion, `P2P_PAGO_SUSCRIPCION__INTENTAR_NUEVAMENTE`);
    history.push(`/paginaPago/${cotizacion.idCotizacion}`);
  };
  const textos = cotizacion?.configuracion?.textos?.finSuscripcion


  return (
    <LoadingWrapper {...values}>
      <DIV stylePath="pagoPlaceToPay.globalStyles" className="container-fluid container-page">
        <NavbarHeader showBack={false} />
        <HeaderPage progreso={80} />
        <div className="row justify-content-center">
          <div className="col-11 col-md-7 mt-3">
            <h4 className="titulo font-weight-bold">
              {estadoSuscripcion === ESTADOS_SUSCRIPCION.APROBADO ?
                textos?.titulo ? textos?.titulo : "Estado de la suscripción" :
                'Estado de la suscripción'}
            </h4>
            <p className="descripcion">
              {estadoSuscripcion === ESTADOS_SUSCRIPCION.APROBADO ?
                textos?.subTitulo ? textos?.subTitulo
                  : "A continuación se detalla el estado de su suscripción"
                : 'A continuación se detalla el estado de su suscripción'}
            </p>
          </div>
        </div>

        <InfoPtp
          valor="1"
          resultado={estadoSuscripcion}
          referencia={idCotizacion}
          pago={estadoPago2}
          label="Cobro prueba"
          periocidadPago="El cobro realizado sera reversado de forma automatica"
        >
          <React.Fragment>
            {estadoSuscripcion === ESTADOS_SUSCRIPCION.RECHAZADO && (
              <div className="col-11 col-sm-8 col-md-6 text-center mt-5">
                <h6 className="label__rechazado">
                  Su petición de suscripción de tarjeta ha sido <strong>rechazada</strong>
                </h6>
              </div>
            )}

            <div className="col-12" />
            {estadoSuscripcion === ESTADOS_SUSCRIPCION.PENDIENTE &&
              !verificandoEstado && (
                <div className="col-11 col-sm-8 col-md-6 mt-4">
                  <h5 className="label__pendiente font-weight-bold text-secondary text-justify">
                    Al parecer el proceso de verificación está tardando más de
                    lo esperado, pronto seras notificado a tu correo{' '}
                    {cotizacion.titular.email}
                  </h5>

                  <h5 className="label__timer mt-3">
                    Se volvera a consultar en{' '}
                    <Timer
                      initialTime={60000}
                      //initialTime={5000}
                      direction="backward"
                    //onFinish={() => setTimeFinished(true)}
                    />
                    {' segundos'}
                  </h5>
                </div>
              )}
            <div className="col-12" />
            <div className="col-11 col-sm-8 col-md-6">
              {verificandoEstado && (
                <ProgressBar
                  className="progresbar__pendiente my-5"
                  animated
                  now={100}
                  label="Verificando estado..."
                />
              )}
            </div>
            <div className="col-12 text-center" >
              <BtnPrincipal label="Mis pagos" onClick={() => history.push(`/listado-pago/${idCotizacion}/${cotizacion.empPtp}`)} style={{width: "120px"}} />
            </div>   
          </React.Fragment>
        </InfoPtp>

        {estadoSuscripcion === ESTADOS_SUSCRIPCION.RECHAZADO && (
          <FooterButton label="Intentar nuevamente" onClick={onClickIntentarNuevamente} />
        )}
      </DIV>
    </LoadingWrapper>
  );
};

export default withCotizacion(PtpPagoSuscripcion);
